import { FC } from "react";

import { DynamicViewData } from "src/dynamic-view-renderer/DynamicViewRenderer.typings.ts";
import { DashboardRowConfiguration } from "src/dynamic-view-renderer/DynamicViewSchemaProvider/DynamicViewSchemaProvider.types.ts";
import WidgetRenderer from "src/dynamic-view-renderer/Widgets/WidgetRenderer.tsx";

type RowRendererProps = {
  rows: DashboardRowConfiguration[];
  data: DynamicViewData;
};

export const RowRenderer: FC<RowRendererProps> = ({ rows, data }) => {
  return rows.map((row, rowIndex) => (
    <div className={`flex gap-5 items-stretch ${row.autoLayout ? "flex-wrap" : ""}`} key={rowIndex}>
      {row.widgets.map((widget, index) => (
        <WidgetRenderer key={index} data={data} rowConfiguration={row} widgetConfig={widget} />
      ))}
    </div>
  ));
};
